import * as Types from './api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainNameQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DomainNameQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', name: string } | null> } | null };

export type DomainQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DomainQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', id: number, name: string } | null> } | null };

export type GroupsQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupList', totalCount?: number | null, items: Array<{ __typename?: 'Group', id: number, name: string, numberId: number, groupType: Types.GroupType, group?: Types.CallGroupType | null, pickup: boolean, sequentialTimeout?: number | null, huntingAlgorithmType: Types.HuntingAlgorithmType, maxQueueLength: number, maxWaitingTime: number, outgoingCallBarringAdmin?: any | null, outgoingCallBarringOperator?: any | null, state?: Types.GroupState | null, hasAddressBook: boolean, size?: number | null } | null> } | null };

export type GroupWithMembersQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GroupWithMembersQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', id: number, name: string, members: Array<{ __typename?: 'GroupMembership', callOrder?: number | null, sectionIndex: number, controllingLine: boolean, state: string, allowEditAddressBook: boolean, number?: { __typename?: 'Number', id: number, e164?: any | null, shortNumber?: string | null, extension?: { __typename?: 'User', id: number, displayName: string } | null } | null }> } | null> } | null };

export type IvrsQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type IvrsQuery = { __typename?: 'Query', ivrs?: { __typename?: 'IvrList', totalCount?: number | null, items: Array<{ __typename?: 'Ivr', id: number, name: string, outgoingCallBarringOperator?: any | null, outgoingCallBarringAdmin?: any | null, outgoingCallBarringUser?: any | null, recordingType: Types.DirectionType, callLimit: number, privateCallerAnnouncement?: { __typename?: 'Media', id: number, description?: string | null, downloadToken?: string | null } | null, number?: { __typename?: 'Number', id: number, nonPaymentBlockingType: Types.NonPaymentBlockingType, e164?: any | null, shortNumber?: string | null } | null } | null> } | null };

export type PersonalExtensionListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PersonalExtensionListQuery = { __typename?: 'Query', personalUsers: Array<{ __typename?: 'PersonalUser', id: number, name?: string | null, e164?: any | null, shortNumber: string, previewFeaturesEnabled: boolean, isOwner?: boolean | null, domain: { __typename?: 'FoundDomain', id: number, name: string } }> };

export type LocationsQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  filter?: Types.InputMaybe<Types.Scalars['String']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type LocationsQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationList', totalCount?: number | null, items: Array<{ __typename?: 'Location', id: number, name: string, description: string, callLimit: number, bandwidthLimit: number, domainId: number, ipAddress?: string | null, pilotNumber: string, emergencyPrefix?: string | null } | null> } | null };

export type ExtensionListFragment = { __typename?: 'User', displayName: string, number?: { __typename?: 'Number', shortNumber?: string | null, e164?: any | null } | null };

export type SpeedDialListFragment = { __typename?: 'SpeedDial', shortNumber: string, targetNumber: string, extensionId: number, description?: string | null, extension?: { __typename?: 'User', featuresRestrictions: Array<Types.FeatureRestriction | null> } | null };

export type DeleteGroupMembershipMutationVariables = Types.Exact<{
  groupId: Types.Scalars['Int']['input'];
  numberId: Types.Scalars['Int']['input'];
}>;


export type DeleteGroupMembershipMutation = { __typename?: 'Mutation', deleteGroupMembership?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string } | null> | null };

export type VendorsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type VendorsQuery = { __typename?: 'Query', vendors?: Array<{ __typename?: 'Vendor', id: number, name: string } | null> | null };

export type DeviceTypeSetsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DeviceTypeSetsQuery = { __typename?: 'Query', deviceTypeSets: Array<{ __typename?: 'DeviceTypeSet', name: string, devices: Array<string> }> };

export type MediaDownloadTokenQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type MediaDownloadTokenQuery = { __typename?: 'Query', media: { __typename?: 'MediaList', items: Array<{ __typename?: 'Media', downloadToken?: string | null }> } };

export type DomainMediaQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  description?: Types.InputMaybe<Types.Scalars['String']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sortBy?: Types.InputMaybe<Array<Types.MediaSortBy>>;
}>;


export type DomainMediaQuery = { __typename?: 'Query', media: { __typename?: 'MediaList', totalCount: number, items: Array<{ __typename?: 'Media', id: number, description?: string | null, mimeType: string, downloadToken?: string | null }> } };

export type DomainDefaultLanguageQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainDefaultLanguageQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', defaultLanguage?: string | null } | null> } | null };

export type SystemLanguagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SystemLanguagesQuery = { __typename?: 'Query', structureConfig: { __typename?: 'StructureConfig', languages: Array<string> } };

export type DomainOutgoingCallBarringsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainOutgoingCallBarringsQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', outgoingCallBarringAdmin?: any | null, outgoingCallBarringOperator?: any | null } | null> } | null };

export const ExtensionListFragmentDoc = gql`
    fragment ExtensionList on User {
  displayName
  number {
    shortNumber
    e164
  }
}
    `;
export const SpeedDialListFragmentDoc = gql`
    fragment SpeedDialList on SpeedDial {
  shortNumber
  targetNumber
  extensionId
  description
  extension {
    featuresRestrictions
  }
}
    `;
export const DomainNameDocument = gql`
    query DomainName($id: Int!) {
  domains(id: $id) {
    items {
      name
    }
  }
}
    `;

/**
 * __useDomainNameQuery__
 *
 * To run a query within a React component, call `useDomainNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDomainNameQuery(baseOptions: Apollo.QueryHookOptions<DomainNameQuery, DomainNameQueryVariables> & ({ variables: DomainNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainNameQuery, DomainNameQueryVariables>(DomainNameDocument, options);
      }
export function useDomainNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainNameQuery, DomainNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainNameQuery, DomainNameQueryVariables>(DomainNameDocument, options);
        }
export function useDomainNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameQuery, DomainNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainNameQuery, DomainNameQueryVariables>(DomainNameDocument, options);
        }
export type DomainNameQueryHookResult = ReturnType<typeof useDomainNameQuery>;
export type DomainNameLazyQueryHookResult = ReturnType<typeof useDomainNameLazyQuery>;
export type DomainNameSuspenseQueryHookResult = ReturnType<typeof useDomainNameSuspenseQuery>;
export type DomainNameQueryResult = Apollo.QueryResult<DomainNameQuery, DomainNameQueryVariables>;
export const DomainDocument = gql`
    query Domain {
  domains {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useDomainQuery__
 *
 * To run a query within a React component, call `useDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainQuery({
 *   variables: {
 *   },
 * });
 */
export function useDomainQuery(baseOptions?: Apollo.QueryHookOptions<DomainQuery, DomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainQuery, DomainQueryVariables>(DomainDocument, options);
      }
export function useDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainQuery, DomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainQuery, DomainQueryVariables>(DomainDocument, options);
        }
export function useDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainQuery, DomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainQuery, DomainQueryVariables>(DomainDocument, options);
        }
export type DomainQueryHookResult = ReturnType<typeof useDomainQuery>;
export type DomainLazyQueryHookResult = ReturnType<typeof useDomainLazyQuery>;
export type DomainSuspenseQueryHookResult = ReturnType<typeof useDomainSuspenseQuery>;
export type DomainQueryResult = Apollo.QueryResult<DomainQuery, DomainQueryVariables>;
export const GroupsDocument = gql`
    query Groups($id: Int, $offset: Int, $limit: Int) {
  groups(id: $id, offset: $offset, limit: $limit) {
    totalCount
    items {
      id
      name
      numberId
      groupType
      group
      pickup
      sequentialTimeout
      huntingAlgorithmType
      maxQueueLength
      maxWaitingTime
      outgoingCallBarringAdmin
      outgoingCallBarringOperator
      state
      hasAddressBook
      size
    }
  }
}
    `;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export function useGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsSuspenseQueryHookResult = ReturnType<typeof useGroupsSuspenseQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const GroupWithMembersDocument = gql`
    query GroupWithMembers($id: Int) {
  groups(id: $id) {
    items {
      id
      name
      members {
        number {
          id
          e164
          shortNumber
          extension {
            id
            displayName
          }
        }
        callOrder
        sectionIndex
        controllingLine
        state
        allowEditAddressBook
      }
    }
  }
}
    `;

/**
 * __useGroupWithMembersQuery__
 *
 * To run a query within a React component, call `useGroupWithMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupWithMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupWithMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupWithMembersQuery(baseOptions?: Apollo.QueryHookOptions<GroupWithMembersQuery, GroupWithMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupWithMembersQuery, GroupWithMembersQueryVariables>(GroupWithMembersDocument, options);
      }
export function useGroupWithMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupWithMembersQuery, GroupWithMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupWithMembersQuery, GroupWithMembersQueryVariables>(GroupWithMembersDocument, options);
        }
export function useGroupWithMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupWithMembersQuery, GroupWithMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupWithMembersQuery, GroupWithMembersQueryVariables>(GroupWithMembersDocument, options);
        }
export type GroupWithMembersQueryHookResult = ReturnType<typeof useGroupWithMembersQuery>;
export type GroupWithMembersLazyQueryHookResult = ReturnType<typeof useGroupWithMembersLazyQuery>;
export type GroupWithMembersSuspenseQueryHookResult = ReturnType<typeof useGroupWithMembersSuspenseQuery>;
export type GroupWithMembersQueryResult = Apollo.QueryResult<GroupWithMembersQuery, GroupWithMembersQueryVariables>;
export const IvrsDocument = gql`
    query Ivrs($id: Int, $offset: Int, $limit: Int) {
  ivrs(id: $id, offset: $offset, limit: $limit) {
    totalCount
    items {
      id
      name
      outgoingCallBarringOperator
      outgoingCallBarringAdmin
      outgoingCallBarringUser
      recordingType
      callLimit
      privateCallerAnnouncement {
        id
        description
        downloadToken
      }
      number {
        id
        nonPaymentBlockingType
        e164
        shortNumber
      }
    }
  }
}
    `;

/**
 * __useIvrsQuery__
 *
 * To run a query within a React component, call `useIvrsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIvrsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIvrsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useIvrsQuery(baseOptions?: Apollo.QueryHookOptions<IvrsQuery, IvrsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IvrsQuery, IvrsQueryVariables>(IvrsDocument, options);
      }
export function useIvrsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IvrsQuery, IvrsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IvrsQuery, IvrsQueryVariables>(IvrsDocument, options);
        }
export function useIvrsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IvrsQuery, IvrsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IvrsQuery, IvrsQueryVariables>(IvrsDocument, options);
        }
export type IvrsQueryHookResult = ReturnType<typeof useIvrsQuery>;
export type IvrsLazyQueryHookResult = ReturnType<typeof useIvrsLazyQuery>;
export type IvrsSuspenseQueryHookResult = ReturnType<typeof useIvrsSuspenseQuery>;
export type IvrsQueryResult = Apollo.QueryResult<IvrsQuery, IvrsQueryVariables>;
export const PersonalExtensionListDocument = gql`
    query PersonalExtensionList {
  personalUsers {
    id
    name
    e164
    shortNumber
    previewFeaturesEnabled
    domain {
      id
      name
    }
    isOwner
  }
}
    `;

/**
 * __usePersonalExtensionListQuery__
 *
 * To run a query within a React component, call `usePersonalExtensionListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalExtensionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalExtensionListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalExtensionListQuery(baseOptions?: Apollo.QueryHookOptions<PersonalExtensionListQuery, PersonalExtensionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalExtensionListQuery, PersonalExtensionListQueryVariables>(PersonalExtensionListDocument, options);
      }
export function usePersonalExtensionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalExtensionListQuery, PersonalExtensionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalExtensionListQuery, PersonalExtensionListQueryVariables>(PersonalExtensionListDocument, options);
        }
export function usePersonalExtensionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalExtensionListQuery, PersonalExtensionListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalExtensionListQuery, PersonalExtensionListQueryVariables>(PersonalExtensionListDocument, options);
        }
export type PersonalExtensionListQueryHookResult = ReturnType<typeof usePersonalExtensionListQuery>;
export type PersonalExtensionListLazyQueryHookResult = ReturnType<typeof usePersonalExtensionListLazyQuery>;
export type PersonalExtensionListSuspenseQueryHookResult = ReturnType<typeof usePersonalExtensionListSuspenseQuery>;
export type PersonalExtensionListQueryResult = Apollo.QueryResult<PersonalExtensionListQuery, PersonalExtensionListQueryVariables>;
export const LocationsDocument = gql`
    query Locations($id: Int, $domainId: Int, $filter: String, $offset: Int, $limit: Int) {
  locations(
    id: $id
    domainId: $domainId
    filter: $filter
    offset: $offset
    limit: $limit
  ) {
    totalCount
    items {
      id
      name
      description
      callLimit
      bandwidthLimit
      domainId
      ipAddress
      pilotNumber
      emergencyPrefix
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      domainId: // value for 'domainId'
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export function useLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsSuspenseQueryHookResult = ReturnType<typeof useLocationsSuspenseQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const DeleteGroupMembershipDocument = gql`
    mutation DeleteGroupMembership($groupId: Int!, $numberId: Int!) {
  deleteGroupMembership(groupId: $groupId, numberId: $numberId) {
    location
    context
    type
  }
}
    `;
export type DeleteGroupMembershipMutationFn = Apollo.MutationFunction<DeleteGroupMembershipMutation, DeleteGroupMembershipMutationVariables>;

/**
 * __useDeleteGroupMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMembershipMutation, { data, loading, error }] = useDeleteGroupMembershipMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      numberId: // value for 'numberId'
 *   },
 * });
 */
export function useDeleteGroupMembershipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMembershipMutation, DeleteGroupMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMembershipMutation, DeleteGroupMembershipMutationVariables>(DeleteGroupMembershipDocument, options);
      }
export type DeleteGroupMembershipMutationHookResult = ReturnType<typeof useDeleteGroupMembershipMutation>;
export type DeleteGroupMembershipMutationResult = Apollo.MutationResult<DeleteGroupMembershipMutation>;
export type DeleteGroupMembershipMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMembershipMutation, DeleteGroupMembershipMutationVariables>;
export const VendorsDocument = gql`
    query Vendors {
  vendors {
    id
    name
  }
}
    `;

/**
 * __useVendorsQuery__
 *
 * To run a query within a React component, call `useVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorsQuery(baseOptions?: Apollo.QueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
      }
export function useVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
        }
export function useVendorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VendorsQuery, VendorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VendorsQuery, VendorsQueryVariables>(VendorsDocument, options);
        }
export type VendorsQueryHookResult = ReturnType<typeof useVendorsQuery>;
export type VendorsLazyQueryHookResult = ReturnType<typeof useVendorsLazyQuery>;
export type VendorsSuspenseQueryHookResult = ReturnType<typeof useVendorsSuspenseQuery>;
export type VendorsQueryResult = Apollo.QueryResult<VendorsQuery, VendorsQueryVariables>;
export const DeviceTypeSetsDocument = gql`
    query DeviceTypeSets {
  deviceTypeSets {
    name
    devices
  }
}
    `;

/**
 * __useDeviceTypeSetsQuery__
 *
 * To run a query within a React component, call `useDeviceTypeSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceTypeSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceTypeSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeviceTypeSetsQuery(baseOptions?: Apollo.QueryHookOptions<DeviceTypeSetsQuery, DeviceTypeSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceTypeSetsQuery, DeviceTypeSetsQueryVariables>(DeviceTypeSetsDocument, options);
      }
export function useDeviceTypeSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceTypeSetsQuery, DeviceTypeSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceTypeSetsQuery, DeviceTypeSetsQueryVariables>(DeviceTypeSetsDocument, options);
        }
export function useDeviceTypeSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeviceTypeSetsQuery, DeviceTypeSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeviceTypeSetsQuery, DeviceTypeSetsQueryVariables>(DeviceTypeSetsDocument, options);
        }
export type DeviceTypeSetsQueryHookResult = ReturnType<typeof useDeviceTypeSetsQuery>;
export type DeviceTypeSetsLazyQueryHookResult = ReturnType<typeof useDeviceTypeSetsLazyQuery>;
export type DeviceTypeSetsSuspenseQueryHookResult = ReturnType<typeof useDeviceTypeSetsSuspenseQuery>;
export type DeviceTypeSetsQueryResult = Apollo.QueryResult<DeviceTypeSetsQuery, DeviceTypeSetsQueryVariables>;
export const MediaDownloadTokenDocument = gql`
    query MediaDownloadToken($id: Int!) {
  media(id: $id) {
    items {
      downloadToken
    }
  }
}
    `;

/**
 * __useMediaDownloadTokenQuery__
 *
 * To run a query within a React component, call `useMediaDownloadTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaDownloadTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaDownloadTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaDownloadTokenQuery(baseOptions: Apollo.QueryHookOptions<MediaDownloadTokenQuery, MediaDownloadTokenQueryVariables> & ({ variables: MediaDownloadTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaDownloadTokenQuery, MediaDownloadTokenQueryVariables>(MediaDownloadTokenDocument, options);
      }
export function useMediaDownloadTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaDownloadTokenQuery, MediaDownloadTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaDownloadTokenQuery, MediaDownloadTokenQueryVariables>(MediaDownloadTokenDocument, options);
        }
export function useMediaDownloadTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaDownloadTokenQuery, MediaDownloadTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaDownloadTokenQuery, MediaDownloadTokenQueryVariables>(MediaDownloadTokenDocument, options);
        }
export type MediaDownloadTokenQueryHookResult = ReturnType<typeof useMediaDownloadTokenQuery>;
export type MediaDownloadTokenLazyQueryHookResult = ReturnType<typeof useMediaDownloadTokenLazyQuery>;
export type MediaDownloadTokenSuspenseQueryHookResult = ReturnType<typeof useMediaDownloadTokenSuspenseQuery>;
export type MediaDownloadTokenQueryResult = Apollo.QueryResult<MediaDownloadTokenQuery, MediaDownloadTokenQueryVariables>;
export const DomainMediaDocument = gql`
    query DomainMedia($domainId: Int!, $description: String, $offset: Int, $limit: Int, $sortBy: [MediaSortBy!]) {
  media(
    domainId: $domainId
    description: $description
    offset: $offset
    limit: $limit
    sortBy: $sortBy
  ) {
    totalCount
    items {
      id
      description
      mimeType
      downloadToken
    }
  }
}
    `;

/**
 * __useDomainMediaQuery__
 *
 * To run a query within a React component, call `useDomainMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainMediaQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      description: // value for 'description'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useDomainMediaQuery(baseOptions: Apollo.QueryHookOptions<DomainMediaQuery, DomainMediaQueryVariables> & ({ variables: DomainMediaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainMediaQuery, DomainMediaQueryVariables>(DomainMediaDocument, options);
      }
export function useDomainMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainMediaQuery, DomainMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainMediaQuery, DomainMediaQueryVariables>(DomainMediaDocument, options);
        }
export function useDomainMediaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainMediaQuery, DomainMediaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainMediaQuery, DomainMediaQueryVariables>(DomainMediaDocument, options);
        }
export type DomainMediaQueryHookResult = ReturnType<typeof useDomainMediaQuery>;
export type DomainMediaLazyQueryHookResult = ReturnType<typeof useDomainMediaLazyQuery>;
export type DomainMediaSuspenseQueryHookResult = ReturnType<typeof useDomainMediaSuspenseQuery>;
export type DomainMediaQueryResult = Apollo.QueryResult<DomainMediaQuery, DomainMediaQueryVariables>;
export const DomainDefaultLanguageDocument = gql`
    query DomainDefaultLanguage($domainId: Int!) {
  domains(id: $domainId) {
    items {
      defaultLanguage
    }
  }
}
    `;

/**
 * __useDomainDefaultLanguageQuery__
 *
 * To run a query within a React component, call `useDomainDefaultLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainDefaultLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainDefaultLanguageQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainDefaultLanguageQuery(baseOptions: Apollo.QueryHookOptions<DomainDefaultLanguageQuery, DomainDefaultLanguageQueryVariables> & ({ variables: DomainDefaultLanguageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainDefaultLanguageQuery, DomainDefaultLanguageQueryVariables>(DomainDefaultLanguageDocument, options);
      }
export function useDomainDefaultLanguageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainDefaultLanguageQuery, DomainDefaultLanguageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainDefaultLanguageQuery, DomainDefaultLanguageQueryVariables>(DomainDefaultLanguageDocument, options);
        }
export function useDomainDefaultLanguageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainDefaultLanguageQuery, DomainDefaultLanguageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainDefaultLanguageQuery, DomainDefaultLanguageQueryVariables>(DomainDefaultLanguageDocument, options);
        }
export type DomainDefaultLanguageQueryHookResult = ReturnType<typeof useDomainDefaultLanguageQuery>;
export type DomainDefaultLanguageLazyQueryHookResult = ReturnType<typeof useDomainDefaultLanguageLazyQuery>;
export type DomainDefaultLanguageSuspenseQueryHookResult = ReturnType<typeof useDomainDefaultLanguageSuspenseQuery>;
export type DomainDefaultLanguageQueryResult = Apollo.QueryResult<DomainDefaultLanguageQuery, DomainDefaultLanguageQueryVariables>;
export const SystemLanguagesDocument = gql`
    query SystemLanguages {
  structureConfig {
    languages
  }
}
    `;

/**
 * __useSystemLanguagesQuery__
 *
 * To run a query within a React component, call `useSystemLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSystemLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<SystemLanguagesQuery, SystemLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemLanguagesQuery, SystemLanguagesQueryVariables>(SystemLanguagesDocument, options);
      }
export function useSystemLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemLanguagesQuery, SystemLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemLanguagesQuery, SystemLanguagesQueryVariables>(SystemLanguagesDocument, options);
        }
export function useSystemLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SystemLanguagesQuery, SystemLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SystemLanguagesQuery, SystemLanguagesQueryVariables>(SystemLanguagesDocument, options);
        }
export type SystemLanguagesQueryHookResult = ReturnType<typeof useSystemLanguagesQuery>;
export type SystemLanguagesLazyQueryHookResult = ReturnType<typeof useSystemLanguagesLazyQuery>;
export type SystemLanguagesSuspenseQueryHookResult = ReturnType<typeof useSystemLanguagesSuspenseQuery>;
export type SystemLanguagesQueryResult = Apollo.QueryResult<SystemLanguagesQuery, SystemLanguagesQueryVariables>;
export const DomainOutgoingCallBarringsDocument = gql`
    query DomainOutgoingCallBarrings($domainId: Int!) {
  domains(id: $domainId) {
    items {
      outgoingCallBarringAdmin
      outgoingCallBarringOperator
    }
  }
}
    `;

/**
 * __useDomainOutgoingCallBarringsQuery__
 *
 * To run a query within a React component, call `useDomainOutgoingCallBarringsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainOutgoingCallBarringsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainOutgoingCallBarringsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainOutgoingCallBarringsQuery(baseOptions: Apollo.QueryHookOptions<DomainOutgoingCallBarringsQuery, DomainOutgoingCallBarringsQueryVariables> & ({ variables: DomainOutgoingCallBarringsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainOutgoingCallBarringsQuery, DomainOutgoingCallBarringsQueryVariables>(DomainOutgoingCallBarringsDocument, options);
      }
export function useDomainOutgoingCallBarringsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainOutgoingCallBarringsQuery, DomainOutgoingCallBarringsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainOutgoingCallBarringsQuery, DomainOutgoingCallBarringsQueryVariables>(DomainOutgoingCallBarringsDocument, options);
        }
export function useDomainOutgoingCallBarringsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainOutgoingCallBarringsQuery, DomainOutgoingCallBarringsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainOutgoingCallBarringsQuery, DomainOutgoingCallBarringsQueryVariables>(DomainOutgoingCallBarringsDocument, options);
        }
export type DomainOutgoingCallBarringsQueryHookResult = ReturnType<typeof useDomainOutgoingCallBarringsQuery>;
export type DomainOutgoingCallBarringsLazyQueryHookResult = ReturnType<typeof useDomainOutgoingCallBarringsLazyQuery>;
export type DomainOutgoingCallBarringsSuspenseQueryHookResult = ReturnType<typeof useDomainOutgoingCallBarringsSuspenseQuery>;
export type DomainOutgoingCallBarringsQueryResult = Apollo.QueryResult<DomainOutgoingCallBarringsQuery, DomainOutgoingCallBarringsQueryVariables>;